<div class="tf-multi-select-container">
    <div  *ngIf="!isCondensed" class="tf-multi-select-dropdown" [ngStyle]="{'border-bottom': overlayVisible ? 'none':''}"
        (click)="onMouseClick($event)"
        [ngClass]="disable ? 'tf-disable-drop-down' : ''">
        <span #toggleButton class="tf-multi-select-placeholder"
            [ngStyle]="{'border-left': isItemSelected ? '4px solid #0f88ea':'4px solid transparent', 'padding': isItemSelected ? '13px 12px 7px 12px' : '10px 12px 10px 12px'}">
            <p *ngIf="isItemSelected">{{defaultLabel}}</p>
                {{valueAsString}}
        </span>

        <i class="tf-arrow"
            [ngStyle]="{'border-bottom': overlayVisible ? '5px solid #222':'', 'border-top': overlayVisible ? '0px': ''}"></i>
        <div *ngIf="displayCloseIcon" class="tf-close-icon" (click)="resetDropDown($event)">
            <i class="tf-icon-close-bold"></i>
        </div>
    </div>

    <div *ngIf="isCondensed" class="tf-multi-select-condensed-dropdown"
        [ngStyle]="{'border-bottom': overlayVisible ? 'none':''}" (click)="onMouseClick($event)"
         [ngClass]="{'tf-condensed-filter': isCondensed, 'tf-disable-drop-down': disable, 'active': overlayVisible}">
        <span #toggleButton [ngClass]="isItemSelected ? 'tf-selected-filter':'tf-default-filter'">
            {{defaultLabel}}
        </span>

        <svg [class.active-arrow]="overlayVisible" [class.selected-arrow]="isItemSelected" width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.59 0.446289L14 1.85629L7 8.85629L0 1.85629L1.42 0.446289L7 6.03629L12.59 0.446289Z" />
        </svg>
            
    </div>

    <div #filters *ngIf="overlayVisible" class="tf-multi-select-options" [style.max-height]="scrollHeight + 'px'||'auto'" [style.min-width]="overlayWidth">
        <!-- Label section -->
        <div *ngIf="isCondensed" class="tf-dropdown-filter-name">
            <span class="tf-label">{{defaultLabel}}</span>
            <div class="tf-multi-select-close-ctrn" (click)="onCloseFilters()">
              <div class="close-ctnr">
                <svg viewBox="0 0 10 10">
                  <line x1="1" y1="1" x2="9" y2="9"/>
                  <line x1="1" y1="9" x2="9" y2="1"/>
                </svg>
              </div>
            </div>
        </div>
        <!-- Search section -->
        <div *ngIf="search" class="tf-dropdown-search-box">
            <span class="tf-dropdown-search-icon">
                <svg class="tf-search-icon-svg" width="14" height="14" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M22.9099 21.5612L17.3199 15.9712C20.5594 12.0274 20.2174 6.25452 16.5349 2.72072C12.8524 -0.81308 7.07034 -0.916996 3.26324 2.4822C-0.543853 5.88139 -1.09308 11.6382 2.00259 15.696C5.09826 19.7537 10.7956 20.745 15.0799 17.9712L20.7899 23.6712L22.9099 21.5612ZM5.01989 14.5612C2.7689 12.28 2.4421 8.7266 4.23925 6.07304C6.0364 3.41948 9.45731 2.40427 12.411 3.64794C15.3647 4.8916 17.0292 8.04802 16.387 11.1879C15.7448 14.3277 12.9747 16.5772 9.76989 16.5612C7.98843 16.5581 6.28066 15.8498 5.01989 14.5912V14.5612Z" fill="#222222"/>
                </svg>
            </span>

            <input autofocus tfFormInput [placeholder]="searchPlaceHolder" (ngModelChange)="filterOptions($event)"
                    [name]="searchPlaceHolder"
                    [(ngModel)]="searchInputValue" class="tf" />

            <svg *ngIf="hasClearBtn" (click)="!isLoadingData && onClearKeyword()" class="tf-dropdown-clear-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path class="clear-icon-path" fill-rule="evenodd" clip-rule="evenodd" d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM9 4.29289L7 6.29289L5.13333 4.42623L4.42623 5.13333L6.29289 7L4.29289 9L5 9.70711L7 7.70711L8.86667 9.57377L9.57377 8.86667L7.70711 7L9.70711 5L9 4.29289Z" fill="#92929E"/>
            </svg>
        </div>

        <div class="tf-filter-content">
          <div *ngIf="!isLoadingData">
              <div *ngIf="!isEmpty()">
                  <div *ngIf="!virtualScroll">
                      <div *ngFor="let option of visibleOptions | sortBy: 'sortProperty' : sortBy">
                          <li [attr.title]="getLabel(option)" (click)="onOptionWrapperClick($event, option)" class="tf-filter-item">
                              <tf-checkbox [id]="getLabel(option)" [label]="getLabel(option)" [name]="getLabel(option)"
                                           [(ngModel)]="option['isChecked']" (onClick)="onOptionClick($event,option)"
                                           width="100%"></tf-checkbox>
                          </li>
                      </div>
                  </div>
                  <virtual-scroller
                      *ngIf="virtualScroll"
                      #scroll
                      class="virtual-scroller"
                      [items]="visibleOptions | sortBy: 'sortProperty' : sortBy"
                      [enableUnequalChildrenSizes]="true">
                      <div *ngFor="let option of scroll.viewPortItems">
                          <li [attr.title]="getLabel(option)" (click)="onOptionWrapperClick($event, option)" class="tf-filter-item">
                              <tf-checkbox [id]="getLabel(option)" [label]="getLabel(option)" [name]="getLabel(option)"
                                           [(ngModel)]="option['isChecked']" (onClick)="onOptionClick($event,option)"
                                           width="100%">
                              </tf-checkbox>
                          </li>
                      </div>
                  </virtual-scroller>
              </div>

              <div *ngIf="isEmpty()" class="tf-search-icon">
                  No matches found
              </div>
          </div>

          <div *ngIf="isLoadingData" class="tf-search-icon">
            <svg class="loading-svg-icon" viewBox="0 0 28 28">

              <path fill="#eee"
                    d="M14,27C6.83,27,1,21.17,1,14S6.83,1,14,1c7.17,0,13,5.83,13,13S21.17,27,14,27z M14,3C7.93,3,3,7.93,3,14 s4.93,11,11,11s11-4.93,11-11S20.07,3,14,3z"/>
              <path fill="#e71316" d="M14,1v2c6.07,0,11,4.93,11,11s-4.93,11-11,11v2c7.17,0,13-5.83,13-13S21.17,1,14,1z">
                <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 14 14" to="360 14 14"
                                  dur="1s" repeatCount="indefinite"/>
              </path>
            </svg>
          </div>
        </div>
    </div>
</div>
